export const NOTIFICATION_PREFERENCES_UPDATED_MODAL_ID = 'notification_preferences_updated_modal';

export const showNotificationPreferencesUpdatedModal = () => {
  const element = document.getElementById(NOTIFICATION_PREFERENCES_UPDATED_MODAL_ID) as HTMLDialogElement | null;
  element?.showModal?.();
};

export const closeNotificationPreferencesUpdatedModal = () => {
  const element = document.getElementById(NOTIFICATION_PREFERENCES_UPDATED_MODAL_ID) as HTMLDialogElement | null;
  element?.close?.();
};
